var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.showPreview),expression:"this.showPreview"}],staticClass:"tp-wrapper"},[_c('img',{staticClass:"tp-url",attrs:{"src":this.url,"alt":""}}),_c('p',{staticClass:"tp-name"},[_vm._v(_vm._s(_vm.$t(this.situationName)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }